import axios from 'axios';
import { getCookie } from './cookieFunctions';

// Create a new instance of Axios
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_KEY as string,
});

// Add a request interceptor to attach the token from cookies
axiosInstance.interceptors.request.use(
  (config: any) => {
    // Get the token from your cookie (replace 'getCookieToken' with your actual function)
    const token = getCookie('peliswan_crm_token');

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.log('Error :>', error);

    return Promise.reject(error);
  },
);

export default axiosInstance;
